<template>
    <DelayHydration>
        <BaseImage
            v-if="posterImage && !requestedPlayback"
            :image="posterImage"
            class="base-video-embed__placeholder"
            aria-label="Press ENTER to play video"
            tabindex="0"
            sizes="(min-width: 1440px) 1253px, 87vw"
            @click="requestedPlayback = true"
            @keydown.enter="requestedPlayback = true"
        />
        <VideoEmbed
            v-else
            loading="eager"
            :autoplay="!posterImage ? false : true"
            class="base-video-embed"
            v-bind="$attrs"
        >
            <template
                v-for="(_, slot) of $slots"
                v-slot:[slot]="scope"
            >
                <slot
                    :name="slot"
                    v-bind="scope"
                />
            </template>
        </VideoEmbed>
    </DelayHydration>
</template>

<script setup>
import VideoEmbed from '@digitalnatives/video-embed';


defineProps({
    posterImage: {
        type: Object,
        required: false,
        default: undefined
    },
});

const requestedPlayback = ref(false);
</script>

<style lang="less">
.base-video-embed {
    aspect-ratio: 16/9;
}

.base-video-embed__placeholder {
    position: relative;
    cursor: pointer;

    &:before {
        content: '';

        width: 2rem;
        height: 2rem;

        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) scale(1);
        transform-origin: center center;
        background: url('@/assets/img/icons/play.svg') center center no-repeat;
        z-index: 10;

        transition: transform 300ms ease-out;
    }

    &:hover, &:focus-visible {
        &:before {
            transform: translate(-50%, -50%) scale(1.5);
        }
    }

    &:active {
        &:before {
            transform: translate(-50%, -50%) scale(10) opacity(.5);
        }
    }
}
</style>
